import React from 'react'
import { AuthenticationInputPropTypes } from 'utils/prop_types/AuthenticationInput'
import Select2 from 'components/atoms/Select2'
import Icon from 'components/shared/input/Icon'

export default class SelectInput extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      value: this.props.defaultValue,
    }

    this.textValue = undefined
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleSelect(e) {
    const targetSelectedIndex = e.target.options[e.target.selectedIndex]
    if (targetSelectedIndex) this.textValue = targetSelectedIndex.text

    this.setState({ value: e.target.value })
    this.props.handleChange(e)
  }

  render() {
    const {
      icon,
      name,
      defaultValue,
      selectOptions,
      options,
      required,
    } = this.props

    return (
      <div>
        {icon && <Icon name={icon} />}
        <Select2
          name={name}
          value={this.state.value}
          defaultValue={defaultValue}
          data={selectOptions || []}
          onSelect={this.handleSelect}
          options={options}
          required={required}
        />
      </div>
    )
  }
}

SelectInput.propTypes = AuthenticationInputPropTypes
SelectInput.defaultProps = {
  type: 'text',
  validations: [],
  selectOptions: [],
  required: false,
}
